module.exports = __webpack_public_path__ + "img/new-banner-1.8c53ef22.gif";